export type MainInsuranceGoal = "CREDIT_INSURANCE" | "RISK_INSURANCE";
export const MAIN_INSURANCE_GOAL = [
	{
		value: "RISK_INSURANCE",
		label: "Haláleset",
	},
	{
		value: "CREDIT_INSURANCE",
		label: "Hitelek fizetése nem várt eseménynél",
	},
];

export type AdditionalInsuranceGoal = "DISABILITY" | "ACCIDENT_PROTECTION" | "DREAD_DISEASE";
export const ADDITIONAL_INSURANCE_GOAL = [
	{
		value: "DISABILITY",
		label: "Rokkantság (bármely okú)",
	},
	{
		value: "ACCIDENT_PROTECTION",
		label: "Baleseti védelem",
	},
	{
		value: "DREAD_DISEASE",
		label: "Kritikus egészségügyi problémák",
	},
];
